import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'



const getPromocodes = async (userId, type) => {
    const { data: promocodes, error: promocodesError } = await supabase
        .from('promocodes')
        .select('*')
        // .eq('user', userId)
        .eq('type', type)
        .eq('is_active', true);

    if (promocodesError) {
        throw new Error(`Error fetching promocodes: ${promocodesError.message}`);
    }

    if (!promocodes || promocodes.length === 0) {
        return [];
    }

    return promocodes;
};


export default function useGetPromocodes(userId, type) {
    return useQuery({
        queryKey: ['useGetPromocodes', userId, type],
        queryFn: () => getPromocodes(userId, type),
        staleTime: 0,
    })
}
